import script from "./AddTeamDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddTeamDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AddTeamDialog.vue?vue&type=style&index=0&id=2963aee2&lang=sass"

const __exports__ = script;

export default __exports__